"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const typography_1 = __importDefault(require("./typography"));
// TODO: Here we're building a hybrid of theme values from Merlin and styling
//       currently specific to task-based. Ideally we want to merge this all into
//       Merlin. But there're big issues of backwards-compatibility to think of,
//       and currently no other client needs these.
const theme = Object.assign(Object.assign({}, merlin_theme_1.default), { typography: Object.assign(Object.assign({}, typography_1.default), { fonts: merlin_theme_1.default.typography.fonts }), colours: Object.assign(Object.assign({}, merlin_theme_1.default.colours), { tip: {
            default: '#4D22EC',
            tint: '#f5f2ff'
        } }), 
    // TODO: Define task-based spacing in here and use that in place of Merlin spacings
    layout: {
        container: {
            maxWidth: '800px',
        },
        radius: Object.assign(Object.assign({}, merlin_theme_1.default.layout.radius), { squared: '4px' }),
        spacing: {
            smallest: '5px',
            smaller: '10px',
            small: '15px',
            standard: '20px',
            large: '30px',
            xLarge: '40px'
        },
        zIndex: {
            pageHeader: 15,
            taskNavigator: 10,
            stickyHeader: 5,
        }
    } });
exports.default = theme;
//# sourceMappingURL=theme.js.map